import React from 'react'
import PropTypes from 'prop-types'

const BillIcon2 = ({ size = '45' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 46 46"
      fill="none">
      <path
        d="M37.2317 4.87091H12.8504C12.7633 4.87081 12.6771 4.88871 12.5967 4.92359C12.5163 4.95846 12.4432 5.00964 12.3816 5.07417C12.3201 5.13871 12.2713 5.21535 12.238 5.29969C12.2048 5.38403 12.1877 5.47442 12.1878 5.56569V31.4862C12.192 33.0333 11.9035 34.5659 11.3389 35.9953C10.7743 37.4247 9.94484 38.7224 8.89861 39.8132C8.80587 39.9104 8.7427 40.0342 8.7171 40.169C8.6915 40.3039 8.70462 40.4436 8.7548 40.5706C8.80498 40.6977 8.88997 40.8062 8.999 40.8825C9.10803 40.9589 9.23621 40.9996 9.36731 40.9995H33.7486C33.8356 40.9995 33.9217 40.9815 34.0021 40.9465C34.0824 40.9115 34.1553 40.8601 34.2166 40.7954C35.3863 39.576 36.3136 38.1252 36.9448 36.5273C37.5759 34.9293 37.8984 33.2158 37.8934 31.4862V5.56569C37.8935 5.47449 37.8765 5.38416 37.8433 5.29987C37.8101 5.21558 37.7613 5.13898 37.6999 5.07446C37.6384 5.00993 37.5654 4.95874 37.4851 4.92381C37.4048 4.88889 37.3186 4.87091 37.2317 4.87091ZM36.5691 31.4862C36.5771 34.5125 35.4662 37.4244 33.47 39.6099H10.8408C12.5797 37.2955 13.5216 34.4327 13.5136 31.4862V6.26047H36.5691V31.4862Z"
        fill="black"
        stroke="black"
        strokeWidth="0.826587"
      />
      <path
        d="M17.4433 15.0119H32.6415C32.8172 15.0119 32.9857 14.9387 33.11 14.8084C33.2342 14.6781 33.304 14.5014 33.304 14.3172C33.304 14.1329 33.2342 13.9562 33.11 13.8259C32.9857 13.6956 32.8172 13.6224 32.6415 13.6224H17.4433C17.2676 13.6224 17.0991 13.6956 16.9748 13.8259C16.8506 13.9562 16.7808 14.1329 16.7808 14.3172C16.7808 14.5014 16.8506 14.6781 16.9748 14.8084C17.0991 14.9387 17.2676 15.0119 17.4433 15.0119Z"
        fill="black"
        stroke="black"
        strokeWidth="0.826587"
      />
      <path
        d="M17.4433 19.7201H32.6415C32.8172 19.7201 32.9857 19.6469 33.11 19.5166C33.2342 19.3863 33.304 19.2096 33.304 19.0253C33.304 18.8411 33.2342 18.6644 33.11 18.5341C32.9857 18.4038 32.8172 18.3306 32.6415 18.3306H17.4433C17.2676 18.3306 17.0991 18.4038 16.9748 18.5341C16.8506 18.6644 16.7808 18.8411 16.7808 19.0253C16.7808 19.2096 16.8506 19.3863 16.9748 19.5166C17.0991 19.6469 17.2676 19.7201 17.4433 19.7201Z"
        fill="black"
        stroke="black"
        strokeWidth="0.826587"
      />
      <path
        d="M17.4433 24.4265H32.6415C32.8172 24.4265 32.9857 24.3533 33.11 24.223C33.2342 24.0927 33.304 23.916 33.304 23.7317C33.304 23.5474 33.2342 23.3707 33.11 23.2404C32.9857 23.1101 32.8172 23.0369 32.6415 23.0369H17.4433C17.2676 23.0369 17.0991 23.1101 16.9748 23.2404C16.8506 23.3707 16.7808 23.5474 16.7808 23.7317C16.7808 23.916 16.8506 24.0927 16.9748 24.223C17.0991 24.3533 17.2676 24.4265 17.4433 24.4265Z"
        fill="black"
        stroke="black"
        strokeWidth="0.826587"
      />
      <path
        d="M17.4433 29.1347H32.6415C32.8172 29.1347 32.9857 29.0615 33.11 28.9312C33.2342 28.8009 33.304 28.6242 33.304 28.4399C33.304 28.2556 33.2342 28.0789 33.11 27.9486C32.9857 27.8183 32.8172 27.7451 32.6415 27.7451H17.4433C17.2676 27.7451 17.0991 27.8183 16.9748 27.9486C16.8506 28.0789 16.7808 28.2556 16.7808 28.4399C16.7808 28.6242 16.8506 28.8009 16.9748 28.9312C17.0991 29.0615 17.2676 29.1347 17.4433 29.1347Z"
        fill="black"
        stroke="black"
        strokeWidth="0.826587"
      />
    </svg>
  )
}

export default React.memo(BillIcon2)

BillIcon2.propTypes = {
  size: PropTypes.string,
  color: PropTypes.string,
}
